import React from "react";
import { TopbarIconButton } from "./TopbarIconButton";
import { Tooltip } from "@mui/material";

export const IconButtonWithTitle: React.FC<{
    action?: () => void;
    disabled?: boolean;
    title: string;
    icon: JSX.Element;
    testId?: string;
    selected?: boolean;
}> = ({ action, disabled, title, icon, testId, selected }) => {
    const button = (
        <TopbarIconButton
            onClick={() => action!()}
            data-testid={testId}
            disabled={disabled}
            classes={{
                root: selected ? "TopbarIconButton-selected" : undefined,
            }}
        >
            {icon}
        </TopbarIconButton>
    );

    if (!disabled) {
        return (
            <Tooltip
                title={title}
                data-testid={testId}
            >
                {button}
            </Tooltip>
        );
    }
    return button;
};
